<svelte:options tag="fds-image-editor-text-toolbar"></svelte:options>
<script>
    import {get_current_component} from "svelte/internal"
    
    let fonts = ["Montez","Lobster","Josefin Sans","Shadows Into Light","Pacifico","Amatic SC", "Orbitron", "Rokkitt","Righteous","Dancing Script","Bangers","Chewy","Sigmar One","Architects Daughter","Abril Fatface","Covered By Your Grace","Kaushan Script","Gloria Hallelujah","Satisfy","Lobster Two","Comfortaa","Cinzel","Courgette"];
    let host = get_current_component()

    export let values={selectedLayer:{
      font_size:150,
      letter_spacing: 1,
      bold:false,
      italic:false,
      underline:false
    }}

    function action(name,value) {
        host.dispatchEvent( new CustomEvent("action", {detail:{name:name,value:value}}))
    }
    function change(name,value) {
        host.dispatchEvent( new CustomEvent("change", {detail:{name:name,value:value}}))
    }    
    $: if (values) { 
      values=values
    }
    let editText

</script>

<div class="paletteHorizontal">
  <div class="paletteHorizontalInner">
    <div style="position:relative;display:inline-block">
    Text | 
    {#if values.selectedLayer}
      Font Size: <span class="values3">{values.selectedLayer.font_size}</span>
        <!---
        <input type="range" class="slider" min="50" max="900"  on:input={(e) => { values.selectedLayer.font_size=e.target.value;values=values;change("change","font_size") }} value={values.selectedLayer.font_size} style="margin-right:20px;">
        --->
        <fds-slider  class="slider" min="50" max="900"  on:input={(e) => { values.selectedLayer.font_size=e.target.value;values=values;change("change","font_size") }} value={values.selectedLayer.font_size} style="margin-right:20px;"></fds-slider>



           <button on:click={() => { editText=!editText; }} class="bw_button" style="margin-left:20px; margin-right: 20px;margin-top:5px"  >Text/Font...</button>




      {#if editText }
      <div class="editText">        
        <select class="formInput" style="margin-top:5px;display:inline-block;width:200px;color:black;background-color:white;font-family:{values.selectedLayer.font};font-size:20px"
        on:change={(e) => { values.selectedLayer.font=e.target.value;values=values;change("change","font") }} 
        >
          {#each fonts as font}
            <option style="font-family:{font}" selected={ values.selectedLayer.font===font ? "selected" : undefined}>{font}</option>
          {/each}
        </select> 
        Letter Spacing: <span class="values3">{values.selectedLayer.letter_spacing}</span>
        <!---
        <input type="range" class="slider" min="-2" max="8"  step="0.1" on:input={(e) => { values.selectedLayer.letter_spacing=e.target.value;values=values;change("change","letter_spacing") }} value={values.selectedLayer.letter_spacing} style="margin-right:20px;">
        --->
        <fds-slider class="slider" min="-2" max="8"  step="0.1" on:input={(e) => { values.selectedLayer.letter_spacing=e.target.value;values=values;change("change","letter_spacing") }} value={values.selectedLayer.letter_spacing} style="margin-right:20px;"></fds-slider>
        <div class="buttoncontainer">
          <button on:click={() => { values.selectedLayer.bold=!values.selectedLayer.bold;change("change","font_weight") }} class="tbIcon" style="margin-left:0px; margin-right: 5px;margin-top:5px;font-weight: bold;"  >B</button>
          <button on:click={() => { values.selectedLayer.italic=!values.selectedLayer.italic;change("change","font_style"); }} class="tbIcon" style=" margin-right: 5px;margin-top:5px; font-style: italic;"  >I</button>
          <button on:click={() => { values.selectedLayer.underline=!values.selectedLayer.underline;change("change","text_decoration"); }} class="tbIcon" style=" margin-right: 5px;margin-top:5px; text-decoration:underline;">U</button>
        </div>

        <div class="formLine">
          <textarea class="formInput" style="height:100px;font-size:20px;font-family:{values.selectedLayer.font}" on:change={(e) => { values.selectedLayer.string=e.target.value;values=values;change("change","text") }} >{values.selectedLayer.string}</textarea>
        </div>
      </div>
      {/if}
    {/if}
  </div>
  </div>
</div>

<style>
       * {
            box-sizing: border-box;
        }
.buttoncontainer {
  margin-bottom: 10px;
  padding-bottom: 5px;;
  border-bottom: 1px solid white;
}
.tbIcon {
    height:30px; 
    width:30px;
    stroke: var(--btn-text-color);
    fill: var(--btn-text-color);
    stroke-width:0.0px;
    padding: 5px;
    border: 1px transparent solid;
    border-radius: 5px;
}
.tbIcon:hover,.active { /* ,.tbIcon:focus */
        transition: all .4s ease-in-out;
        background-color: var(--btn-selected-bgcolor);
        border: 1px solid var(--btn-selected-border-color);
        cursor: pointer;
        stroke: var(--btn-selected-text-color);
        fill: var(--btn-selected-text-color);
        outline: none;
    }
.bw_button {
   background-color: var(--btn-bw-simple-bgcolor);
   color: var(--btn-bw-simple-color);
   padding: 3px 10px;
   font-size: 12px;
   font-weight: normal;
   font-family: system-ui, "Segoe UI", Roboto;
   border: 0;
   border-radius: 3px;
   cursor: pointer;
}
.bw_button:hover {
   background-color: var(--btn-bw-simple-bgcolor-hover);
   color: var(--btn-bw-simple-color-hover);
}


.editText {
  min-width: 200px;
  min-height: 100px;
  font-size:12px;
	box-shadow: 0 0 1rem 0 rgba(255,255, 255, .2);
	border-radius: 5px;
	background-color: rgba(0, 0, 0, .65);
	backdrop-filter: blur(10px);
  color: rgba(255,255,255, 0.6);

  position:absolute;
  left:150px;
  top:50px;
  padding: 10px;
  font-family: "Segoe UI", Roboto, system-ui;
  z-index: 2000;
  margin-left: 100px;
}

.formLine {
  displaY:block;
  margin-bottom:20px;
}
.paletteHorizontalInner {
  padding: 5px 0;
}



.paletteHorizontal {
    vertical-align: middle;
}
.slider {
    vertical-align: middle;
}
.values3 {
    width:30px;
    text-align:right;
    display: inline-block;
}

 .formInput {
  width: 100%;
  outline: 0;
    border: 0;
    border-bottom: 2px solid rgba(255,255,255, 0.2);
    
    padding: 5px;
    font-size: 14px;
    font-weight: normal;
    border-radius: 3px;
    color: rgba(255,255,255, 0.9);
    margin-bottom: 10px;
    display: block;
    background: none;    
    font-family: system-ui, "Segoe UI", Roboto;

}
 .formInput::placeholder {
    font-weight: normal;
    opacity: 0.5;
    color: rgba(255,255,255, 0.7);
}


 
.formLine {
  margin-bottom: 5px;
}


</style>